import { createSlice } from "@reduxjs/toolkit"

const initialState = {
    value: null,
}

export const profileSlice = createSlice({
    name: 'profile',
    initialState,
    reducers:{
        setProfile: (state, actions) => {
            state.value = actions.payload;
        }
    }
})

export const { setProfile } = profileSlice.actions
export default profileSlice.reducer